import * as React from "react";

function SvgSortUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 12.95"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M24.04 11.51a1.4 1.4 0 01-.44 1 1.5 1.5 0 01-1.06.42h-21a1.46 1.46 0 01-1-.42 1.37 1.37 0 01-.45-1 1.35 1.35 0 01.45-1L10.95.43a1.48 1.48 0 011.09-.44 1.51 1.51 0 011 .44l10.5 10.07a1.38 1.38 0 01.5 1.01z" />
    </svg>
  );
}

const MemoSvgSortUp = React.memo(SvgSortUp);
export default MemoSvgSortUp;
